import { render } from "./AutocompleteChips.vue?vue&type=template&id=049d16be&scoped=true&ts=true"
import script from "./AutocompleteChips.vue?vue&type=script&lang=ts"
export * from "./AutocompleteChips.vue?vue&type=script&lang=ts"

import "./autocomplete-input.scss?vue&type=style&index=0&id=049d16be&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049d16be"]])

export default __exports__